import {req, Version, Service, source, url} from './base'


export const QueryFreeTrialWallet = req.wrap({
    url,
    params: {
        Action: 'QueryFreeTrialWallet',
        Version,
        Service,
        source
    }
})

export const QueryUserSpecialDiscounts = req.wrap({
    url,
    params: {
        Action: 'QueryUserSpecialDiscounts',
        Version,
        Service,
        source
    }
})


export const QueryKvmList = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'QueryKvmList',
        Version,
        Service,
        source
    }
})

export const RegionInfos = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'RegionInfos',
        Service,
        Version,
        source
    }
})


export const ImageConfig = req.wrap({
    url,
    params: {
        Action: 'ImageConfig',
        Service,
        Version,
        source
    }
})

export const DescribeImages = req.wrap({
    url,
    params: {
        Action: 'DescribeImages',
        Service,
        Version,
        source
    }
})

export const DescribeLocalVolumeSnapshots = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'DescribeLocalVolumeSnapshots',
        Service,
        Version,
        source
    }
})


// ebs
export const DescribeSnapshots = req.wrap({
    url,
    params: {
        Action: 'DescribeSnapshots',
        Version,
        Service,
        source
    },
    method: 'POST'
})


//获取竞价实例历史价格
export const DescribeSpotPriceHistory = req.wrap({
    url,
    params: {
        Action: 'DescribeSpotPriceHistory',
        Version,
        Service,
        source
    }
});

export const DescribeMarketImages = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'DescribeMarketImages',
        Version,
        Service,
        source
    }
})


export const ValidateIpv6Support = req.wrap({
    url,
    params: {
        Action: 'ValidateIpv6Support',
        Version,
        source,
        Service, //: 'kec'
    },
})


export const DescribeSnapshotServiceStatus = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'DescribeSnapshotServiceStatus',
        Service, //: 'kec',
        Version,
        source
    }
})


export const OpenSnapShotService = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'OpenSnapShotService',
        Service, //: 'kec',
        Version,
        source
    }
})


export const GetInstanceByIds = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'GetInstanceByIds',
        Service,
        Version,
        source
    }
})


// 获取主机详情--实例启动模板使用
export const DescribeModels = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'DescribeModels',
        Service,
        Version,
        source
    }
});


export const DescribeInstanceGroupCount = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'DescribeInstanceGroupCount',
        Service,
        Version,
        source
    }
});

//查询云盘类型的全部性能配额配置
export const DescribeEbsPerfQuotas = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'DescribeEbsPerfQuotas',
        Service,
        Version,
        source
    }
});

export const CalculateKVMPrice = req.wrap({
    url,
    params: {
        Action: 'CalculateKVMPrice',
        Version,
        Service,
        source
    },
    method: 'POST'
});

//查询通用折扣信息
export const QueryCommonDiscount = req.wrap({
    url,
    params: {
        Action: 'QueryCommonDiscount',
        Service,
        Version,
        source,
    }
});

export const BatchCalculateKVMPrice = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'BatchCalculateKVMPrice',
        Service,
        Version,
        source,
    }
});

// as api
export const QueryPriceSystem = req.wrap({
    url,
    method: 'POST',
    params: {
        Action: 'QueryPriceSystem',
        Service,
        Version,
        source,
        productGroupId: 100,
        vmType: 'as',
    }
})
